// Канал элементов в промпт-баре: выбор из библиотеки, состояние пикера и
// просмотр элемента целиком. Кадры уже собраны своим хуком (`useChatAttachments`
// / `useImageRoleSlots`) — элементы держим симметрично, чтобы компонент бара
// оставался раскладкой, а не местом, где живёт логика обоих каналов.

import { useCallback, useMemo, useState } from "react";

import { useGenerationElements } from "~/features/pick-generation-elements";

import type { Element } from "~/entities/element";

interface UsePromptElementsParams {
    chatId: string | null;
    /** `mode.maxElements` текущего режима; `null` — режим элементы не принимает. */
    maxElements: number | null;
}

export function usePromptElements({ chatId, maxElements }: UsePromptElementsParams) {
    const elements = useGenerationElements({ chatId, maxElements });
    const [pickerOpen, setPickerOpen] = useState(false);
    // Слот показывает только первую картинку, а элемент — набор, поэтому по
    // клику открываем его ленту целиком.
    const [viewedId, setViewedId] = useState<string | null>(null);

    /** Пары `id → name` для подстановки `@имя` в промпт и сверки коллизий. */
    const mentionable = useMemo(
        () => elements.selectedElements.map((element) => ({ id: element.id, name: element.name })),
        [elements.selectedElements],
    );

    const viewedElement = useMemo<Element | null>(
        () => elements.selectedElements.find((element) => element.id === viewedId) ?? null,
        [elements.selectedElements, viewedId],
    );

    const closeView = useCallback(() => setViewedId(null), []);

    return {
        ...elements,
        mentionable,
        pickerOpen,
        setPickerOpen,
        viewedElement,
        view: setViewedId,
        closeView,
    };
}
